<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-healthpicks-login></app-healthpicks-login>
  </div>

  <!-- <div *ngIf="page === 'register'">
    <app-healthpicks-register></app-healthpicks-register>
  </div> -->

  <div *ngIf="page === 'forgot-password'">
    <app-healthpicks-forgot-password></app-healthpicks-forgot-password>
  </div>


  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-healthpicks-change-password-sent></app-healthpicks-change-password-sent>
  </div>

  <!-- <app-healthpicks-register-resend
    *ngIf="page === 'register-resend'"
  ></app-healthpicks-register-resend> -->
</ng-container>
